import {CAS_ROZPRACOVANI_KEY, ORDER_STORAGE_PREFIX} from "../const/const";
import {ORDER_ROUTES} from "../const/routes";

/**
 * Uloží data do local storage. Data musí být serializable.
 *
 * @param userId ID uživatele kterému data patří
 * @param key unikátní klíč pod kterým uložit data
 * @param data objekt s daty k uložení
 */
export function save(userId, key, data) {
    localStorage.setItem(`${userId}_${key}`, JSON.stringify(data));
}

/**
 * Načte data z local storage.
 *
 * @param userId ID uživatele kterému data patří
 * @param key unikátní klíč
 * @returns {Object} objekt s daty
 */
export function load(userId, key) {
    return JSON.parse(localStorage.getItem(`${userId}_${key}`));
}

/**
 * Odstraní data z local storage.
 *
 * @param userId ID uživatele kterému data patří
 * @param key unikátní klíč
 */
export function clear(userId, key) {
    localStorage.removeItem(`${userId}_${key}`);
}

/**
 * Uloží data pro konkrétní krok objednávky.
 *
 * @param userId ID uživatele
 * @param step číslo kroku objednávky
 * @param data data k uložení
 */
export function saveOrderData(userId, step, data) {
    localStorage.setItem(`${userId}_${ORDER_STORAGE_PREFIX}_${step}`, JSON.stringify(data));
}

/**
 * Načte data pro konkrétní krok objednávky.
 *
 * @param userId uživatele
 * @param step číslo kroku objednávky
 */
export function loadOrderData(userId, step) {
    return JSON.parse(localStorage.getItem(`${userId}_${ORDER_STORAGE_PREFIX}_${step}`));
}

/**
 * Odstraní data pro konkrétní krok objednávky.
 *
 * @param userId ID uživatele
 * @param step číslo kroku objednávky
 */
export function clearOrderData(userId, step) {
    localStorage.removeItem(`${userId}_${ORDER_STORAGE_PREFIX}_${step}`);
}

/**
 * Odstraní všechna uložená data objednávky.
 *
 * @param userId ID uživatele
 */
export function clearAllOrderData(userId) {
    for (let i = 1; i <= ORDER_ROUTES.length; i++) {
        localStorage.removeItem(`${userId}_${ORDER_STORAGE_PREFIX}_${i}`);
    }
    localStorage.removeItem(`${userId}_${CAS_ROZPRACOVANI_KEY}`);
}

/**
 * Vrátí nejvyšší číslo kroku objednávky pro který jsou uložena data.
 *
 * @param uzivatelId ID uživatele
 */
export function getLastSavedOrderStep(uzivatelId) {
    for (let i = ORDER_ROUTES.length; i > 0; i--) {
        if (loadOrderData(uzivatelId, i)) return i;
    }
}

/**
 * Vrátí nejvyšší číslo kroku objednávky pro který jsou uložena data a má nastaven atribut finished = true.
 *
 * @param uzivatelId ID uživatele
 */
export function getLastSavedFinishedOrderStep(uzivatelId) {
    for (let i = ORDER_ROUTES.length; i > 0; i--) {
        const data = loadOrderData(uzivatelId, i);
        if (data && data.finished) return i;
    }
}
